/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface IdeaGetAll
 */
export interface IdeaGetAll {
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaGetAll
     */
    postIds: Array<string>;
}

export function IdeaGetAllFromJSON(json: any): IdeaGetAll {
    return {
        'postIds': json['postIds'],
    };
}

export function IdeaGetAllToJSON(value?: IdeaGetAll): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'postIds': value.postIds,
    };
}


